define('commons/pie-chart',['jquery', 'd3js'], function($, d3) {

    var PieChart = function(container, name, options) {
        this.options = {
            'width': 300,
            'height': 300,
            'radius': 130,
            'inner': 60,
            'margin': 30,
            'selectedColor': '#f1c40f',
            'showLegend': true,
            'legendWidth': 200,
            'legendBulletOffset': 40,
            'legendBulletSize': 5,
            'legendBulletSelectedSize': 8,
            'legendTextOffset': 15,
            'scrollTriangleOffset': 10,
            'textVerticalSpace': 20,
            'scrollSpace': 50,
            'sort': true,
            'unit': '',
            'onSelect': undefined
        };
        // Extends options
        $.extend(this.options, options);
        this.name = name;
        this.container = container;
        $(this.container).css('width', this.options.width);
        $(this.container).css('height', this.options.height);
        this.defaultColors = d3.scale.category20c();
        this.draw();
    };

    PieChart.prototype.isInt = function(n) {
        return n % 1 === 0;
    };

    PieChart.prototype.sortItem = function(a, b) {
        if (this.options.sort) {
            return b.value - a.value;
        } else {
            return null;
        }
    };

    PieChart.prototype.draw = function() {
        if (this.vis === undefined) {
            var self = this;
            var width;
            if (this.options.showLegend) {
                width = this.options.width + this.options.legendWidth;
            } else {
                width = this.options.width;
            }

            $(this.container).css('width', width);

            this.vis = d3.select(this.container).append('svg:svg').attr('width', width).attr('height', this.options.height).attr('class',
                    'svg-' + this.name).append('svg:g').attr('transform', 'translate(0,0)');
            this.textTop = this.vis.append('text').attr('dy', '.35em').style('text-anchor', 'middle').attr('class', 'textTop').text('TOTAL').attr(
                    'y', -10).attr('transform',
                    'translate(' + (this.options.radius + this.options.margin) + ', ' + (this.options.radius + this.options.margin) + ')');
            this.textBottom = this.vis.append('text').attr('dy', '.35em').style('text-anchor', 'middle').attr('class', 'textBottom').attr('y', 10)
                    .attr('transform',
                            'translate(' + (this.options.radius + this.options.margin) + ', ' + (this.options.radius + this.options.margin) + ')');

            this.arc = d3.svg.arc().innerRadius(this.options.inner).outerRadius(this.options.radius);

            this.arcOver = d3.svg.arc().innerRadius(this.options.inner + 5).outerRadius(this.options.radius + 5);

            this.pie = d3.layout.pie().value(function(d) {
                return d.value;
            });
            if (this.options.showLegend) {
                var legendContainer = d3.select('.svg-' + this.name).append('svg:svg').attr('width', width).attr('height',
                        this.options.height + this.options.scrollSpace).attr('x', this.options.width).attr('y', 0);
                this.legend = legendContainer.append('svg:svg').attr('width', this.options.legendWidth).attr('height',
                        this.options.height - this.options.scrollSpace).attr('x', 0).attr('y', this.options.scrollSpace / 2).append('svg:g').attr(
                        'id', 'legend-' + this.name).attr('transform', 'translate(0,0)');
                this.viewScale = d3.scale.linear().domain([1, 0]).range([0, this.options.height]);
                var zoom = d3.behavior.zoom().on("zoom", function() {
                    var scale = d3.event.scale;
                    self.scroll(self, -1 * self.viewScale(scale));
                }).scaleExtent([0.00001, 1]);
                this.legend.call(zoom);
                this.scrollingBox = legendContainer.append('svg:g').attr('transform', 'translate(0, 0)');
            }
        }
    };

    PieChart.prototype.getColor = function(context) {
        return function(d, i) {
            if (d.data !== undefined) {
                d = d.data;
            }
            if (d.class === undefined) {
                return context.defaultColors(i);
            } else {
                switch (d.class) {
                    case 'red':
                        return '#c0392b';
                    case 'green':
                        return '#1abc9c';
                    case 'orange':
                        return '#e67e22';
                    case 'gray':
                        return '#7F8C8D';
                    default:
                        return '#7f8c8d';
                }
            }
        };
    };

    PieChart.prototype.updateData = function(data) {
        var self = this;
        this.total = d3.sum(data, function(d) {
            return d.value;
        }).toFixed(0);
        self.textBottom.text(this.total + this.options.unit);
        this.vis.data([data]);
        this.vis.selectAll('g.slice').remove();

        var arcs = this.vis.selectAll('g.slice').data(this.pie).enter().append('svg:a').attr('xlink:href', function(d) {
            return d.data.link == "empty" ? "javascript:void(0)" : d.data.link;
        }).attr('class', function(d) {
            return d.data.link_class;
        })
        .append('svg:g').attr('class', 'slice').style('stroke', 'White').attr('d', this.arc).attr('transform',
                'translate(' + (this.options.radius + this.options.margin) + ', ' + (this.options.radius + this.options.margin) + ')');

        arcs.append('svg:path').attr('fill', this.getColor(this)).attr('color_value', this.getColor(this)).attr('index_value', function(d, i) {
            return 'index-' + i;
        }).attr('class', function(d, i) {
            return 'pie-' + self.name + '-arc-index-' + i;
        }).style('stroke', 'White').style('cursor', function(d, i) {
            if (d.data.link !== undefined && d.data.link !== '') {
                return 'pointer';
            } else {
                return 'default';
            }
        }).attr('d', this.arc).on('mouseover', this.mouseOver(this, true)).on('mouseout', this.mouseOut(this)).on('click', this.mouseClick(this));
        arcs.filter(function(d) {
            return d.endAngle - d.startAngle > 0.1;
        }).append("svg:text").attr("dy", ".35em").attr("text-anchor", "middle").attr("transform", function(d) {
            d.outerRadius = self.options.radius;
            d.innerRadius = self.options.inner;
            return "translate(" + self.arc.centroid(d) + ")";
        }).style("fill", "#ecf0f1").style("font", "12px Arial").text(function(d) {
            return d.data.otherValue;
        });

        if (this.options.showLegend) {

            this.legend.selectAll('circle').remove();
            this.legend.selectAll('a').remove();
            this.scrollingBox.selectAll('a').remove();

            var scrolling = (this.options.radius * 2) < (data.length * this.options.textVerticalSpace);
            this.legend.attr('scrolling', scrolling);
            this.dataHeight = (data.length * this.options.textVerticalSpace) - (this.options.height - this.options.scrollSpace);
            this.viewScale.range([0, this.dataHeight]);
            $(this.container).css('width', this.options.width + this.options.legendWidth);

            d3.select('.svg-' + this.name).attr('width', this.options.width + this.options.legendWidth);

            var group = this.legend.selectAll('a.legend_link').data(data).enter().append('svg:a').attr('xlink:href', function(d, i) {
                var indexValue = 'index-' + i;
                var arcSelector = '.' + 'pie-' + self.name + '-arc-' + indexValue;
                var selectedArc = d3.selectAll(arcSelector);
                var link = selectedArc.datum().data.link;
                return link == "empty" ? "javascript:void(0)" : link;
            }).attr('class', function(d, i) {
                var indexValue = 'index-' + i;
                var arcSelector = '.' + 'pie-' + self.name + '-arc-' + indexValue;
                var selectedArc = d3.selectAll(arcSelector);
                var customClass = selectedArc.datum().data.link_class;
                return "legend_link " + (customClass != undefined ? customClass : "");
            });

            group.append('svg:rect').attr('x', this.options.legendBulletOffset - this.options.legendBulletSize).attr('y', function(d, i) {
                return i * self.options.textVerticalSpace + self.options.scrollTriangleOffset - self.options.textVerticalSpace / 2;
            }).attr('width', this.options.legendWidth).attr('height', this.options.textVerticalSpace).attr('fill', 'white').attr('color_value',
                    this.getColor(this)).attr('index_value', function(d, i) {
                return 'index-' + i;
            }).style('cursor', 'pointer').on('mouseover', this.mouseOver(this, false)).on('mouseout', this.mouseOut(this)).on('click',
                    this.mouseClick(this));

            group.append('svg:circle').attr('cx', this.options.legendBulletOffset).attr('cy', function(d, i) {
                return i * self.options.textVerticalSpace + self.options.scrollTriangleOffset;
            }).attr('stroke-width', '.5').style('fill', this.getColor(this)).attr('r', this.options.legendBulletSize).attr('class', function(d, i) {
                return 'pie-' + self.name + '-legendBullet-index-' + i;
            }).attr('color_value', this.getColor(this)).attr('index_value', function(d, i) {
                return 'index-' + i;
            }).style('cursor', 'pointer').on('mouseover', this.mouseOver(this, false)).on('mouseout', this.mouseOut(this)).on('click',
                    this.mouseClick(this));
            group.append('text').attr('text-anchor', 'center').attr('x',
                    this.options.legendBulletOffset + this.options.legendTextOffset + this.options.legendBulletSize).attr('y', function(d, i) {
                return i * self.options.textVerticalSpace + self.options.scrollTriangleOffset;
            }).attr('dx', 0).attr('dy', this.options.legendBulletSize + 'px').text(function(d) {
                return d.name;
            }).attr('class', function(d, i) {
                return 'pie-' + self.name + '-legendText-index-' + i;
            }).style('fill', this.getColor(this)).attr('color_value', this.getColor(this)).attr('index_value', function(d, i) {
                return 'index-' + i;
            }).style('cursor', 'pointer').on('mouseover', this.mouseOver(this, false)).on('mouseout', this.mouseOut(this)).on('click',
                    this.mouseClick(this));

            if (scrolling) {
                this.scrollingBox.append('svg:a').append('svg:path').attr('d', d3.svg.symbol().type('triangle-up')).style('fill', 'grey').attr(
                        'transform', 'translate(' + this.options.legendWidth / 2 + ',10)').on('mouseover', this.scrollLegend("DOWN", this)).on(
                        'mouseout', this.stopScroll(this));
                this.scrollingBox.append('svg:a').append('svg:path').attr('d', d3.svg.symbol().type('triangle-down')).style('fill', 'grey').attr(
                        'transform',
                        'translate(' + this.options.legendWidth / 2 + ',' + (this.options.height - this.options.scrollTriangleOffset) + ')').on(
                        'mouseover', this.scrollLegend("UP", this)).on('mouseout', this.stopScroll(this));
            }
        }
    };

    PieChart.prototype.stopScroll = function(context) {
        return function() {
            context.scrolling = false;
        };
    };

    PieChart.prototype.scroll = function(context, offset) {
        if (context.legend.attr('scrolling') == 'true') {
            context.legend.transition().duration(100).attr('transform', 'translate(' + [0, offset] + ')');
        }
    };

    PieChart.prototype.scrollLegend = function(direction, context) {
        return function() {
            context.scrolling = true;
            var timer = setInterval(function() {
                if (context.scrolling) {
                    switch (direction) {
                        case "UP":
                            offset = -5;
                            break;
                        default:
                            offset = 5;
                            break;
                    }
                    var t = d3.transform(context.legend.attr("transform")), x = t.translate[0], y = t.translate[1];
                    var tick = y + offset;
                    if (tick >= 0) {
                        tick = 0;
                        context.scrolling = false;
                    } else if (tick <= -1 * context.dataHeight) {
                        tick = -1 * context.dataHeight;
                        context.scrolling = false;
                    }
                    context.legend.attr('transform', 'translate(' + [0, tick] + ')');
                } else {
                    clearInterval(timer);
                }
            }, 30);
        };
    };

    PieChart.prototype.mouseClick = function(context) {
        return function() {
            if (context.options.onSelect !== undefined) {
                var indexValue = d3.select(this).attr('index_value');
                var arcSelector = '.' + 'pie-' + context.name + '-arc-' + indexValue;
                var selectedArc = d3.selectAll(arcSelector);
                var name = selectedArc.datum().data.name;
                context.options.onSelect.call(this, name);
            }
        };
    };

    PieChart.prototype.mouseOver = function(context, goToLegend) {
        return function() {
            var self = d3.select(this);
            var indexValue = self.attr('index_value');
            var colorValue = self.attr('color_value');
            var arcSelector = '.' + 'pie-' + context.name + '-arc-' + indexValue;
            var selectedArc = d3.selectAll(arcSelector);
            if (context.options.showLegend) {
                selectedArc.style('fill', context.options.selectedColor);
                var bulletSelector = '.' + 'pie-' + context.name + '-legendBullet-' + indexValue;
                var selectedLegendBullet = d3.selectAll(bulletSelector);
                selectedLegendBullet.style('fill', context.options.selectedColor).attr('r', context.options.legendBulletSelectedSize);
                var textSelector = '.' + 'pie-' + context.name + '-legendText-' + indexValue;
                var selectedLegendText = d3.selectAll(textSelector);
                selectedLegendText.style('fill', context.options.selectedColor);
                if ((context.legend.attr('scrolling') == 'true') && goToLegend) {
                    var boxHeight = context.options.height - context.options.scrollSpace;
                    var elementPosition = selectedLegendText.attr('y');
                    if (elementPosition > boxHeight) {
                        context.scroll(context, -1 * (elementPosition - (boxHeight / 2)));
                    } else {
                        context.scroll(context, 0);
                    }
                }
            }
            selectedArc.transition().duration(200).attr('d', context.arcOver);
            context.textTop.text(selectedArc.datum().data.name).attr('y', -10);
            var value = selectedArc.datum().data.value;
            context.textBottom.text(context.isInt(value) ? value : value.toFixed(2) + context.options.unit).attr('y', 10);
        };
    };

    PieChart.prototype.mouseOut = function(context) {
        return function() {
            var self = d3.select(this);
            var indexValue = self.attr('index_value');
            var colorValue = self.attr('color_value');
            var arcSelector = '.' + 'pie-' + context.name + '-arc-' + indexValue;
            var selectedArc = d3.selectAll(arcSelector);
            if (context.options.showLegend) {
                selectedArc.style('fill', colorValue);
                var bulletSelector = '.' + 'pie-' + context.name + '-legendBullet-' + indexValue;
                var selectedLegendBullet = d3.selectAll(bulletSelector);
                selectedLegendBullet.style('fill', colorValue).attr('r', context.options.legendBulletSize);
                var textSelector = '.' + 'pie-' + context.name + '-legendText-' + indexValue;
                var selectedLegendText = d3.selectAll(textSelector);
                selectedLegendText.style('fill', colorValue);
            }
            selectedArc.transition().duration(100).attr('d', context.arc);
            context.textTop.text('TOTAL').attr('y', -10);
            context.textBottom.text(context.total + context.options.unit);
        };
    };

    return PieChart;
});
